document.addEventListener('DOMContentLoaded', function () {
  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }
  if (navigator.onLine && document.getElementById('weather_widget')) {
    fetch('/wp-json/weather/current', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(handleErrors)
      .then((response) => response.json())
      .then((data) => {
        const weatherWidget = document.getElementById('weather_widget');

        const icon = weatherWidget.getElementsByClassName('icon');
        const temp = weatherWidget.getElementsByClassName('temp');

        temp[0].innerText = data.temp + '°';
        icon[0].classList.replace(icon[0].classList[1], 'icon-' + data.icon);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});
